// GenericActionButton.js
import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

const GenericActionButton = ({ actions }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    }
    
    const handleMenuClose = (event) => {
        setAnchorEl(null);
    }


    // const actions = [
    //     { label: 'Action 1', onClick: console.log("A") },
    //     { label: 'Action 2', onClick: console.log("B") },
    // ];

    return (
        <>
            <Button
                variant="contained" // Ensure the styling matches other buttons
                endIcon={<KeyboardArrowDown />} // Down arrow icon
                aria-controls="actions-menu"
                aria-haspopup="true"
                onClick={handleMenuClick}
            >
                Actions
            </Button>
            <Menu
                id="actions-menu"
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={handleMenuClose}
                MenuListProps={{ 'aria-labelledby': 'actions-button' }}
            >
                {actions.map((action, index) => (
                    <MenuItem key={index} onClick={() => { action.onClick(); handleMenuClose(); }}>
                        {action.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default GenericActionButton;
